<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66602 4.0013C2.66602 3.26492 3.26297 2.66797 3.99935 2.66797H5.33268C6.06906 2.66797 6.66602 3.26492 6.66602 4.0013V5.33464C6.66602 6.07101 6.06906 6.66797 5.33268 6.66797H3.99935C3.26297 6.66797 2.66602 6.07101 2.66602 5.33464V4.0013Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.33268 4.0013C9.33268 3.26492 9.92964 2.66797 10.666 2.66797H11.9993C12.7357 2.66797 13.3327 3.26492 13.3327 4.0013V5.33464C13.3327 6.07101 12.7357 6.66797 11.9993 6.66797H10.666C9.92964 6.66797 9.33268 6.07101 9.33268 5.33464V4.0013Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.66602 10.668C2.66602 9.93159 3.26297 9.33464 3.99935 9.33464H5.33268C6.06906 9.33464 6.66602 9.93159 6.66602 10.668V12.0013C6.66602 12.7377 6.06906 13.3346 5.33268 13.3346H3.99935C3.26297 13.3346 2.66602 12.7377 2.66602 12.0013V10.668Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.33268 10.668C9.33268 9.93159 9.92964 9.33464 10.666 9.33464H11.9993C12.7357 9.33464 13.3327 9.93159 13.3327 10.668V12.0013C13.3327 12.7377 12.7357 13.3346 11.9993 13.3346H10.666C9.92964 13.3346 9.33268 12.7377 9.33268 12.0013V10.668Z"
      stroke="black"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {};
</script>
